import { render, staticRenderFns } from "./CSPJView.vue?vue&type=template&id=42888c95&"
import script from "./CSPJView.vue?vue&type=script&lang=js&"
export * from "./CSPJView.vue?vue&type=script&lang=js&"
import style0 from "./CSPJView.vue?vue&type=style&index=0&id=42888c95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports